import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import {
  appOpenOnboardingModalEffect,
  appReopenOnboardingModalEffect,
  userGetDataOnBackgroundEffect,
} from 'store/effects';
import { link } from 'settings/navigation/link';

import styles from './styles.module.scss';
import { useHistory } from 'react-router-dom';
import { getUserDataSelector } from 'store/selectors/user';
import { capitalize } from 'lodash';

export const Welcome = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(getUserDataSelector);

  const LottieWelcomeLink =
    'https://lottie.host/93088fc7-8c37-4df0-8dc3-16ba1894b486/oaDjT6ePYR.json';

  useEffect(() => {
    setTimeout(() => {
      dispatch(userGetDataOnBackgroundEffect({}, { showError: false }));
      dispatch(appReopenOnboardingModalEffect({ open: false }));
      dispatch(appOpenOnboardingModalEffect({ open: true }));
      history.replace(link.toHome());
    }, 6000);
  }, []);

  return (
    <div className={styles.welcomeScreen}>
      <div className={styles.innerContainer}>
        <DotLottieReact
          src={LottieWelcomeLink}
          loop
          autoplay
          speed={0.5}
          className={styles.lottieContainer}
        />
        <p className={styles.welcomeText}>
          Welcome to Mosaik {user?.FirstName ? `, ${capitalize(user?.FirstName)}` : ''}!
        </p>
        <p className={styles.welcomeSubtitleText}>We are setting up your account...</p>
      </div>
    </div>
  );
};
